/**
 * Setup the environment for grid items
 */
import { Logger } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Setup the environment for box items
 */
export default class BoxItemEnvironment {
    /**
     * @param {AbstractItem} item
     * @param {Pimple} container
     */
    constructor(item, container) {
        this.item = item;

        this.container = container;
        this.layerManager = container.get('canvas.svg.layerManager');
        this.pathFactory = container.get('canvas.svg.pathFactory');
    }

    init() {
        Logger.debug('BoxItemEnvironment.init():', this.item);

        // box wrap
        this.itemLayer = this.layerManager.createItemLayer(this.item, {
            transform: this.pathFactory.getAbsoluteTransformString(this.item),
        });

        // Move item layer when the foam item is moved inside a box
        this.item.on('change', (box) => {
            if (box.hasChangedProperty('position')) {
                this.itemLayer.getElement().attr('transform', this.pathFactory.getAbsoluteTransformString(box, true));
            }
        });

        // box layer
        this.layerManager.createLayer('box', null, false, this.itemLayer);
    }

    activate() {
        Logger.debug('BoxItemEnvironment.activate():', this.item);

        this.itemLayer.show();
    }

    deactivate() {
        Logger.debug('BoxItemEnvironment.deactivate():', this.item);

        this.itemLayer.hide();
    }
}
